// Integrytas Group - Field Lineage (FLN)
// Title-bar control that flips the workspace into informational "Inspect" mode:
// every field/column becomes a click target revealing where its data comes from.
// GLOBAL (via the shell chrome bridge), so it persists as you navigate. Styled
// for the blue app header, sized to match the About icon beside it.

import { useTranslation } from 'react-i18next';
import { Locate } from 'lucide-react';
import { useShellChrome } from '../../lib/shell_chrome';

export function DataLineageToggle() {
  const { t } = useTranslation();
  const chrome = useShellChrome();
  if (!chrome) return null;   // only meaningful in the shell header
  const { isInspecting, toggleInspecting } = chrome;

  return (
    <button
      type="button"
      data-testid="data-lineage-toggle"
      onClick={toggleInspecting}
      aria-pressed={isInspecting}
      title={isInspecting
        ? t('fln.toggle.exit', 'Exit data-source inspection')
        : t('fln.toggle.enter', 'Show where each field’s data comes from')}
      className={
        'flex h-7 w-7 items-center justify-center rounded ' +
        (isInspecting ? 'bg-white/20 text-white' : 'text-white/80 hover:bg-white/10 hover:text-white')
      }
    >
      <Locate className="h-4 w-4" />
    </button>
  );
}
